import React, { useMemo } from 'react'

import { textPalette, fonts } from '@masfront/common-b2c'

import { Box } from '@material-ui/core'

import { Price } from '~/basket/model/common/price.model'
import { formatPriceStr } from '~/prices/prices.helpers'

export default function DisplayPrices({ prices }: { prices: Price[] }) {
  function createOneString(pricessArr: Price[]) {
    let str = ''
    pricessArr.forEach((price, i, arr) => {
      if (arr.length === 1) {
        str = `<strong>${formatPriceStr(price.value)}€/mes</strong>`
        return str
      }
      if (i === 0) {
        str += `<p><strong>${formatPriceStr(price.value)}€/mes</strong> durante ${
          price.duration.amount
        } meses, `
      } else if (i === arr.length - 1) {
        str += `después <strong>${formatPriceStr(price.value)}€/mes</strong>.</p>`
      } else {
        str += `los ${price.duration.amount} meses siguientes <strong>${formatPriceStr(
          price.value,
        )}€/mes</strong>, `
      }
      return str
    })
    return str
  }

  const pricesStr = useMemo(() => createOneString(prices), [prices])

  return (
    <Box
      fontSize={fonts.size.base}
      color={textPalette.secondary}
      fontFamily={fonts.primary}
      dangerouslySetInnerHTML={{ __html: pricesStr }}
    />
  )
}
